import { render, staticRenderFns } from "./KoreanLsports.vue?vue&type=template&id=b5e94494&scoped=true"
import script from "./KoreanLsports.vue?vue&type=script&lang=js"
export * from "./KoreanLsports.vue?vue&type=script&lang=js"
import style0 from "./KoreanLsports.vue?vue&type=style&index=0&id=b5e94494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e94494",
  null
  
)

export default component.exports